import { pSBCr } from "./darken-color.js";

function luminance(c) {
  if (typeof c != "string" || (c[0] != "r" && c[0] != "#")) return null;
  const f = pSBCr(c);

  return 0.2126 * f.r + 0.7152 * f.g + 0.0722 * f.b;
}

export default luminance;
